import React from 'react';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import {
  onClickAssignToItem,
  onClickRow,
  categoriesRequest,
} from 'actions/businessLibrary/category';
import { isDirty } from 'redux-form';
import { askConfirmAction } from 'actions/confirm-action';

import styles from './List.css';

class List extends React.Component {
  render() {
    const { categories, categoryDetail } = this.props;

    return (
      <div className={styles.wrapper}>
        <div className={styles['div-table']}>
          <table className={styles['table-header']}>
            <thead>
              <tr>
                <th className={styles.name}>Category Name</th>
                <th className={styles.stocks}>Item Stocks</th>
                <th className={styles.assign} />
              </tr>
            </thead>
          </table>
          <div
            className={`${
              styles['table-content-wrapper']
            } category-table-content-wrapper`}
          >
            <InfiniteScroll
              pageStart={1}
              loadMore={this.onReachBottom}
              hasMore={this.hasMore()}
              useWindow={false}
              threshold={10}
              initialLoad={false}
            >
              <table className={styles['table-content']}>
                <tbody>
                  {categories.map(category => {
                    return (
                      <tr
                        key={category.id}
                        className={
                          categoryDetail && category.id === categoryDetail.id
                            ? styles.selected
                            : ''
                        }
                        onClick={() => this.onClickRow(category)}
                      >
                        <td className={styles.name}>{category.name}</td>
                        <td className={styles.stocks}>
                          {`${category.business_level_item_count} items`}
                        </td>
                        <td className={styles.assign}>
                          <a
                            className="btn btn-default btn-sm"
                            type="button"
                            onClick={e => this.onClickAssignToItem(e, category)}
                          >
                            Assign To Item
                          </a>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </InfiniteScroll>
          </div>
        </div>
      </div>
    );
  }

  onReachBottom = () => {
    const { dispatch, currentPage, totalPage, categories } = this.props;
    if (currentPage < totalPage) {
      dispatch(
        categoriesRequest({ page: currentPage + 1, size: 50 }, categories)
      );
    }
  };

  hasMore = () => {
    const { currentPage, totalPage } = this.props;
    return currentPage < totalPage;
  };

  onClickRow = category => {
    const { isDirtyCategory } = this.props;
    if (isDirtyCategory) {
      this.props.dispatch(askConfirmAction(onClickRow(category)));
    } else {
      this.props.dispatch(onClickRow(category));
    }
  };

  onClickAssignToItem = (event, category) => {
    const { dispatch } = this.props;
    // prevent row to be clicked
    event.preventDefault();
    event.stopPropagation();
    dispatch(onClickAssignToItem(category));
  };
}

function mapStateToProps(state) {
  const {
    categories,
    categoryDetail,
    categoryMeta,
  } = state.businessLibrary.categoryHub;
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  return {
    categories,
    categoryDetail,
    currentPage: categoryMeta.current_page,
    totalPage: categoryMeta.total_pages,
    showLoadingSpinnerPage,
    isDirtyCategory: isDirty('categoryHub')(state),
  };
}

export default connect(mapStateToProps)(List);
